export default __webpack_public_path__ + "static/foyer-decoratif-8f9eeeae6a346f1c8de2a30038340266.jpg";